<template>
    <div v-bind="$attrs">
      <h2 class="mb-4 text-2xl uppercase text-gray-777 font-roboto">
        Grupos
      </h2>
  
      
  
      <div class="mt-7 w-full">
        <div v-if="status != 'connected'" class="w-[162px] h-[162px] mx-auto">
          <p class="text-base mb-2 text-center">
            Whatsapp não conectado! Conecete-se primeiro para selecionar os grupos
          </p>
        </div>
  
        <div v-else-if="status == 'connected'" class="w-full">
            <multi-select-input 
              appendTo="#modal-vinculo-promotor" 
              v-model="item.providers" 
              :multiple="true"
              :options="this.provider_options_all" 
              :error="item.errors.providers"
              class="lg:pr-6 w-full lg:w-1/2 mt-6 mb-6" 
              label="Grupos" />
        </div>

      </div>
    </div>
  </template>
  
<script>
import {
  getWhatsappSessionUuid,
  startWhatsappSession,
  getWhatsappQrCode,
  disconnectWhatsappSession,
  getWhatsappGroups,
} from "./whatsapp";
import { whatsappConnection } from "./socket";
  
export default {
  data() {
    return {
      session: "",
      status: "",
      errorMessage: "",
      qrcode: "",
      username: "",
    };
  },
  
  methods: {
    async whatsappDisconect() {
      try {
        await disconnectWhatsappSession(this.session);
  
        this.status = "starting";
        this.getWhatsappSession();
      } catch (err) {
        this.status = "error";
        this.errorMessage = err.message;
      }
    },
  
    async whatsappQrCode(sessionUuid) {
      try {
        const response = await getWhatsappQrCode(sessionUuid);
  
        this.status = "qrcode";
        this.qrcode = response.qrcode;
      } catch (err) {
        this.status = "error";
        this.errorMessage = err.message;
      }
    },
    async getWhatsappGroups(sessionUuid) {
      try {
        const response = await getWhatsappQrCode(sessionUuid);
  
        this.status = "qrcode";
        this.qrcode = response.qrcode;
      } catch (err) {
        this.status = "error";
        this.errorMessage = err.message;
      }
    },
  
    handleConnectedSession() {
      this.status = "connected";
    },
  
    handleStatus(session) {
      switch (session.status) {
      case "starting":
        this.status = "starting";
        break;
          
      case "connected":
        this.handleConnectedSession();
        break;
  
      case "qrcode":
        this.whatsappQrCode(session.session);
        break;
  
      case "closed":
        this.status = "closed";
        this.errorMessage = "Sessão encerrada, tente novamente";
        break;
      }
    },
  
    // eslint-disable-next-line no-unused-vars
    handleError(_event) {
      this.status = "error";
      this.errorMessage = "Error ao fazer conexão";
    },
  
    async restartSession(sessionUuid) {
      await startWhatsappSession(sessionUuid);
    },
  
    connectSocketWithWhatsapp() {
      console.log(this.session)
      whatsappConnection.openSocketConection(this.session);
  
      whatsappConnection.onStatusChange((event) =>
        this.handleStatus({
          status: event.status,
          session: event.session,
        })
      );
  
      whatsappConnection.onError(this.handleError);
    },
  
    async getWhatsappSession() {
      try {
        const response = await getWhatsappSessionUuid();
  
        this.session = response.uid;
        this.username = response.name;
        this.status = "starting";
  
        console.log(this.session)
  
          
  
        if (response.status == "closed") {
          this.restartSession(this.session);
        } else {
          this.handleStatus({
            status: response.status,
            session: response.uid,
          });
        }
  
        this.connectSocketWithWhatsapp();
      } catch (err) {
        this.status = "error";
        this.errorMessage = err.message;
      }
    },
  },
  
  mounted() {
    this.getWhatsappSession();
  },
  
  unmounted() {
    whatsappConnection.closeSocketConnection();
  },
  
  setup() {
    return {
      dataResponse,
    };
  },
};
</script>
  
  <style>
  .spin {
    animation: spin 1s infinite linear;
  }
  
  @keyframes spin {
    100% {
      transform: rotateZ(360deg);
    }
  }
  </style>
  